import React from 'react';
import * as Render from '../Base/Render';
import { LazyLoadImage } from '../Image';
import Linklist from '../Linklist';

const SubjectIntro = ({ ImgCssClass, TextCssClass, ...props }) => {
  let hyphen;
  if (props.SubjectHeading && props.Heading) hyphen = ` – `;

  const use1177ProfessionDesignSuffix = props.CurrentPageProps.CurrentPageProps?.FeatureToggleSettings?.Use1177ProfessionDesign ? '-vardpersonal' : '';

  return (
    <div className="subject-intro">
      <div className="row expanded small-collapse medium-collapse large-collapse">
        <div className={ImgCssClass}>
          <div className="subject-intro__image-container__wrapper">
            <div className="subject-intro__image-container">
              <Render.Block
                blocks={props.Image}
                propertyName="Image"
                currentPageProps={props.CurrentPageProps}
              >
                <LazyLoadImage
                  className="subject-intro__img"
                  isBackgroundImage={true}
                  Sizes={{
                    sizes:
                      '(max-width: 1024px) 100vw, (max-width: 1199px) 600px, (max-width: 1899px) 75vw, (min-width: 1900px) 1000px, 100vw',
                  }}
                />
              </Render.Block>
            </div>
          </div>
        </div>
        <div className={TextCssClass}>
          <div className="subject-intro__text">
            <div className="row expanded small-collapse medium-collapse large-collapse">
              <div className="small-12 medium-8 medium-centered large-12 columns">
                <div className="subject-intro__text__content">
                  {(props.SubjectHeading || props.Heading) && (
                    <header>
                      <h1
                        className={`subject-intro__subject-heading${use1177ProfessionDesignSuffix}`}
                        aria-label={`${props.SubjectHeading}${hyphen}${props.Heading}`.trim()}
                      >
                        {props.SubjectHeading}
                        <span>
                          {hyphen}
                          {props.Heading}
                        </span>
                      </h1>
                    </header>
                  )}
                  {props.Preamble && (
                    <div className={`subject-intro__preamble${use1177ProfessionDesignSuffix}`}>
                      {' '}
                      {props.Preamble}
                    </div>
                  )}
                  <Linklist
                    className={`subject-intro-linklist${use1177ProfessionDesignSuffix}`}
                    Links={props.Links}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubjectIntro;
